import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { BaseComponent } from '../base-component/base.component';

export interface TabSwitchItem {
  id: string;
  title: string;
  subtitle?: string;
}

@Component({
    selector: 'isophi-tab-switch',
    templateUrl: './tab-switch.component.html',
    styleUrls: ['./tab-switch.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TabSwitchComponent extends BaseComponent {
  @Input() set switchItems(newItems: TabSwitchItem[] | null) {
    this.tabSwitchItems$.next(newItems);
  }

  @Input() set selectedItemId(selected: TabSwitchItem['id'] | null) {
    if (selected === this.selectedItemId$.value) {
      return;
    }
    this.selectedItemId$.next(selected);
  }

  @Output() selectedItemIdChanged = new EventEmitter<TabSwitchItem['id']>();

  protected readonly tabSwitchItems$ = new BehaviorSubject<TabSwitchItem[] | null>(null);

  protected readonly selectedItemId$ = new BehaviorSubject<TabSwitchItem['id'] | null>(null);

  constructor() {
    super();
  }

  protected changeSelectedItem(newSelected: TabSwitchItem['id']) {
    if (newSelected !== this.selectedItemId$.value) {
      this.selectedItemId$.next(newSelected);
      this.selectedItemIdChanged.emit(newSelected);
    }
  }

  protected trackBySwitchItemId(index: number, item: TabSwitchItem) {
    return item.id;
  }
}
